/* src/app/components/notifications-modal/notifications-modal.component.scss */
.modal-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
}
.modal-wrapper .modal-body {
  flex: 1;
  overflow: auto;
}
.modal-wrapper .modal-body .notification-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal-wrapper .modal-body .notification-section-header .title-section {
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 400;
  color: #72727f;
  margin-bottom: 0.5rem;
}
.modal-wrapper .modal-body .notification-section-header .mark-all {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: #155cb4;
  margin-left: auto;
  padding: 0 0 0.5rem;
}
.modal-wrapper .modal-body .notification-section-header.notification-earlier {
  margin-top: 1.875rem;
}
.modal-wrapper .close {
  background-color: #ffffff;
  outline: none;
  box-shadow: none;
}
.modal-wrapper .modal-footer {
  padding-top: 0.9375rem;
  padding-bottom: 0.9375rem;
  border-top: 1px solid rgba(46, 46, 56, 0.08);
}
.modal-wrapper .modal-footer .settings-link {
  padding: 0;
  color: #2e2e38;
}
/*# sourceMappingURL=notifications-modal.component.css.map */
